export const tCreateTable = [
  {
    caption: "INVENTORY",
    createNotifyText: "",
    dashColumns: ["product", "unit", "quantity", "purchasePrice"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "PURCHASE DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        enabled: "true",
        expanded: false,
        name: "purchaseDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "PRODUCT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "product",
        otherFieldsToUpdate: [
          { src: "unit", tgt: "unit" },
          { src: "photos", tgt: "photos" }
        ],
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "supplierShopItems",
        tableField: "productNameEnglish",
        type: "search"
      },
      {
        caption: "UNIT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "unit",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "false",
        expanded: true,
        name: "photos",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      },
      {
        caption: "QUANTITY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "quantity",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PURCHASE PRICE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "purchasePrice",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      }
    ],
    key: "-MESPxTvKu3mKREwBQCB",
    menu: "INVENTORY",
    name: "inventory",
    searchColumns: ["product", "unit", "quantity"],
    updateNotifyText: ""
  },
  {
    caption: "PURCHASE",
    createNotifyText: "",
    dashColumns: [
      "date",
      "receiptAmount",
      "supplierPurchase",
      "sellAmount",
      "cashToShoper",
      "dayEndCashReturn",
      "notes",
      "photos"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "date",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "EXTERNAL PURCHASE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "receiptAmount",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "WHOLE SALE PURCHASE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "supplierPurchase",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "SELL AMOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "sellAmount",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "CASH RECIEVED SHOPPER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "cashToShoper",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "CASH RETURNED BY SHOPPER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "dayEndCashReturn",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PAID ONLINE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "onlinePayments",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "NOTES",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "false",
        name: "notes",
        numOfLines: "8",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "REC PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "photos",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      }
    ],
    key: "-MAt7wR8fQGN1dloefzz",
    menu: "PURCHASE",
    name: "purchase",
    searchColumns: ["date", "receiptAmount", "notes"],
    updateNotifyText: ""
  },
  {
    caption: "SOURCE SUPPLIER",
    createNotifyText: "",
    dashColumns: ["name", "phone", "address"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "name",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PHONE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "phone",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ADDRESS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "address",
        numOfLines: "3",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "BCS SHOP",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "bcsShop",
        selectorType: "table",
        staticSource: [
          { name: "DRY FOOD" },
          { name: "GARMENTS" },
          { name: "FRESH PRODUCE" },
          { name: "" }
        ],
        table: "users",
        tableField: "userCompany",
        type: "search"
      }
    ],
    menu: "SOURCE SUPPLIR",
    name: "sourceSupplier",
    searchColumns: ["name", "phone", "address"],
    updateNotifyText: "",
    key: "-M9wSYF2FUW-5LK_09dm"
  },
  {
    caption: "APP PHOTOS",
    createNotifyText: "",
    dashColumns: ["name", "photos"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "name",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PHOTOS URL",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "photos",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "photos",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      }
    ],
    key: "-M9rtsy6Ywpm7MhVYuGo",
    menu: "APP PHOTOS",
    name: "appPhotos",
    searchColumns: ["name"],
    updateNotifyText: ""
  },
  {
    caption: "SUPPLIER",
    createNotifyText: "",
    deleteNotifyText: "",
    menu: "SUPPLIER",
    name: "dqr",
    updateNotifyText: "",
    key: "-M97w7qNguBWJr0YGfkZ"
  },
  {
    caption: "OPEN BAZAR",
    createNotifyText: "",
    dashColumns: ["title", "message", "photos"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "YOUR NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        isMust: "true",
        name: "name",
        placeholder: "YOUR NAME",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "TITLE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "title",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        placeholder: "SUBJECT OR TITLE",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "MESSAGE TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "SELLING",
        expanded: false,
        name: "messageType",
        placeholder: "10",
        selectorType: "static",
        staticSource: [
          { name: "GENERAL MESSAGE" },
          { name: "SELLING" },
          { name: "BUYING" }
        ],
        type: "search"
      },
      {
        caption: "PRICE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "",
        expanded: false,
        name: "price",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "MESSAGE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "message",
        numOfLines: "8",
        placeholder: "Your Message",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "false",
        name: "photos",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      },
      {
        caption: "AUTHOR",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: true,
        name: "author",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      }
    ],
    key: "-M809qA-6Cp2CQRfBEpb",
    menu: "OPEN BAZAR",
    name: "openBazar",
    searchColumns: ["title", "message", "name", "price"],
    updateNotifyText: ""
  },
  {
    caption: "RIZI TEST",
    createNotifyText: "",
    dashColumns: ["name", "notes"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "name",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "NOTES",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "notes",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "photos",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      },
      {
        caption: "PHOTO2",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: true,
        name: "photo2",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      }
    ],
    key: "-M7joh6z5JnR4NBkB5VH",
    menu: "RIZI MENU",
    name: "riziTest",
    searchColumns: ["name", "notes"],
    updateNotifyText: ""
  },
  {
    caption: "MY SHOP",
    createNotifyText: "",
    dashColumns: [
      "productNameEnglish",
      "category",
      "sortOrder",
      "searchText",
      "productPrice",
      "availability",
      "isPopular",
      "unit",
      "productSupplier",
      "photos"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "CATEGORY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: true,
        name: "category",
        selectorType: "static",
        staticSource: [
          { name: "ALL" },
          { name: "POPULAR" },
          { name: "রান্না করা খাবার" },
          { name: "PREVIOUSLY ORDERED" },
          { name: "FRUITS VEGETABLES " },
          { name: "MEAT FISH" },
          { name: "COOKING OIL INGREDIENTS" },
          { name: "PICKLES" },
          { name: "RICE DAAL NOODLES" },
          { name: "EGGS DAIRY" },
          { name: "SNACKS DRY FOOD" },
          { name: "DRINKS DESSERT" },
          { name: "TOILETRIES" },
          { name: "SANITARY" },
          { name: "LAUNDRY CLEANING" },
          { name: "COSMETICS" },
          { name: "KITCHEN DINING" },
          { name: "TUPPERWARE CONTAINER" },
          { name: "BABY TOYS" },
          { name: "ELECTRONICS ACCESSORIES" },
          { name: "STATIONARY" },
          { name: "OTHERS" }
        ],
        type: "search"
      },
      {
        caption: "AVAILABILITY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "availability",
        selectorType: "static",
        staticSource: [
          { name: "AVAILABLE" },
          { name: "OUT OF STOCK, TOPPING UP IN PROGRESS" }
        ],
        type: "search"
      },
      {
        caption: "NAME ENGLISH",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "productNameEnglish",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        placeholder: "NAME ENGLISH",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "SEARCH TEXT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "searchText",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "SORTY ORDER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "G",
        expanded: false,
        isMust: "true",
        name: "sortOrder",
        placeholder: "input an alphabet such as A, B ...",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PRICE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "productPrice",
        placeholder: "PRICE",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "photos",
        placeholder: "",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      },
      {
        caption: "UNIT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "unit",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "POPULAR",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "isPopular",
        selectorType: "static",
        staticSource: [{ name: "YES" }, { name: "NO" }],
        type: "search"
      },
      {
        caption: "SOURCE SUPPLIER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "sourceSupplier",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "sourceSupplier",
        tableField: "name",
        type: "search"
      },
      {
        caption: "Description",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "productDescription",
        numOfLines: "5",
        placeholder: "Add description about product",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "SUPPLIER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "userCompany",
        expanded: false,
        isHidden: "true",
        name: "productSupplier",
        otherFieldsToUpdate: [
          { src: "userName", tgt: "supplierContactName" },
          { src: "userMobile", tgt: "supplierContactPhone" }
        ],
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "users",
        tableField: "userCompany",
        type: "search"
      },
      {
        caption: "SUPPLIER NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "userName",
        expanded: false,
        isHidden: "true",
        name: "supplierContactName",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "CONTACT PHONE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "userMobile",
        expanded: false,
        isHidden: "true",
        name: "supplierContactPhone",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      }
    ],
    filters: ["isPopular", "category", "availability"],
    key: "-M7Xa21YxX5JQ0yDS8aJ",
    menu: "MY SHOP",
    name: "supplierShopItems",
    searchColumns: [
      "productNameEnglish",
      "productPrice",
      "productSupplier",
      "productDescription",
      "isPopular"
    ],
    updateNotifyText: ""
  },
  {
    author: "",
    caption: "ORDERS",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: [
      "name",
      "mobile",
      "address",
      "deliveryDate",
      "targetDeliveryDate",
      "orderTotal",
      "salesTotal",
      "status",
      "mealType",
      "deliveredBy"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "ORDER DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        expanded: false,
        isMust: "true",
        name: "deliveryDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "STATUS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "NEW",
        expanded: false,
        name: "status",
        selectorType: "static",
        staticSource: [
          { name: "NEW" },
          { name: "WITH GROCER FOR PRICE" },
          { name: "WITH GROCER FOR PACKING" },
          { name: "WAITING FOR LORRY" },
          { name: "LOADED ON LORRY" },
          { name: "DELIVERED" },
          { name: "CANCELLED" }
        ],
        type: "search"
      },
      {
        caption: "ORDER TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "mealType",
        selectorType: "static",
        staticSource: [
          { name: "LUNCH" },
          { name: "DINNER" },
          { name: "GROCERY ONLY" },
          { name: "MIX (FOOD PLUS GROCERY)" },
          { name: "OTHERS" }
        ],
        type: "search"
      },
      {
        caption: "DELIVERED BY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "deliveredBy",
        selectorType: "static",
        staticSource: [{ name: "BCS" }, { name: "DHAKA" }, { name: "TAXI" }],
        type: "search"
      },
      {
        caption: "TAXI AMOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "taxiAmount",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "TAXI PAID BY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "taxiPaidBy",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "users",
        tableField: "userName",
        type: "search"
      },
      {
        caption: "PAID TO",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "paidTo",
        selectorType: "static",
        staticSource: [{ name: "BCS" }, { name: "DHAKA" }],
        type: "search"
      },
      {
        caption: "PAYMENT TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "paymentType",
        selectorType: "static",
        staticSource: [{ name: "CASH" }, { name: "ONLINE" }, { name: "" }],
        type: "search"
      },
      {
        calcType: "mainFieldCalc",
        caption: "SUPPLIER AMOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: true,
        isMust: "false",
        name: "supplierAmount",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PAY TO SUPPLIER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "payToSupplier",
        selectorType: "static",
        staticSource: [{ name: "PENDING" }, { name: "PAID" }],
        type: "search"
      },
      {
        caption: "MOBILE#",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "mobile",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        placeholder: "92290596",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        isMust: "true",
        name: "name",
        placeholder: "তোমার নাম YOUR NAME",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ADDRESS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        isMust: "true",
        name: "address",
        placeholder: "আপনার ঠিকানা UNIT 04-62 BLOCK 768 CHUA CHUKONG S110876",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "TARGET DELIVERY DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        expanded: false,
        name: "targetDeliveryDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ANY SPECIAL INSTRUCTIONS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "specialInstructions",
        numOfLines: "3",
        placeholder:
          "সন্ধ্যা 4 টা থেকে সন্ধ্যা between টার মধ্যে পৌঁছে দিন\nInput any special instructions like delivery only on tuesday and wednesday is possible",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        calcType: "subFieldsSum",
        caption: "ORDER TOTAL",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "orderTotal",
        selectorType: "",
        staticSource: [{ name: "" }],
        subFieldOperation: "SUM",
        subGridField: "amount",
        subGridName: "requestedItems",
        triggerField: "requestedItems",
        type: "calculation"
      },
      {
        caption: "ACTUAL SALE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "salesTotal",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ORDERED ITEMS",
        colDefs: [
          {
            editable: true,
            key: "productNameEnglish",
            name: "NAME",
            resizable: true
          },
          { editable: true, key: "unit", name: "UNIT", resizable: true },
          {
            editable: true,
            key: "productPrice",
            name: "PRICE",
            resizable: true
          },
          { editable: true, key: "quantity", name: "QTY", resizable: true },
          { editable: true, key: "amount", name: "AMT", resizable: true }
        ],
        defaultValue: "",
        expanded: false,
        isMust: "true",
        name: "requestedItems",
        numOfLines: "25",
        placeholder:
          "Onion 1Kg\nDates 1Packet\nSugar 1Kg\n\nপেঁয়াজ 1 কেজি\nতারিখ 1 প্যাকেট\nচিনি 1 কেজি",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "array"
      },
      {
        caption: "SUPPLIER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "supplier",
        selectorType: "static",
        staticSource: [
          { name: "ALL" },
          { name: "RAJDHANI" },
          { name: "TANMOY" },
          { name: "ZARA" },
          { name: "SUPPLIER4" },
          { name: "SUPPLIER5" }
        ],
        type: "search"
      },
      {
        caption: "SUPPLIER PRICES",
        colDefs: [
          {
            editable: true,
            key: "supplierName",
            name: "SUPPLIER",
            resizable: true
          },
          { editable: true, key: "price", name: "PRICE", resizable: true },
          { editable: true, key: "notes", name: "NOTES", resizable: true }
        ],
        expanded: false,
        name: "supplierPrices",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "array"
      },
      {
        caption: "PHOTOS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "photos",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "photoUpload"
      }
    ],
    filters: ["status", "deliveryDate", "targetDeliveryDate", "mealType"],
    key: "-M5tSI7US3QYXqi7K7XU",
    lastAction: "",
    menu: "ORDERS",
    name: "deliveryRequest",
    searchColumns: [
      "mobile",
      "name",
      "address",
      "status",
      "deliveryDate",
      "mealType",
      "targetDeliveryDate",
      "orderTotal"
    ],
    updateDateTime: "",
    updateNotifyText: ""
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    caption: "USERS",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: [
      "userName",
      "sortOrder",
      "userCompany",
      "recordType",
      "roleName",
      "userMobile",
      "userAddress"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "RECORD TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "STORE USER",
        expanded: false,
        name: "recordType",
        selectorType: "static",
        staticSource: [
          { name: "STANDARD USER" },
          { name: "PROMOTIONAL" },
          { name: "STORE USER" }
        ],
        type: "search"
      },
      {
        caption: "SORT ORDER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "",
        expanded: false,
        name: "sortOrder",
        placeholder: "1",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ROLE NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "roleName",
        selectorType: "table",
        staticSource: [
          { name: "SALES" },
          { name: "ENGINEER" },
          { name: "CONTRIBUTOR" },
          { name: "QS" },
          { name: "ADMIN" },
          { name: "SUPERADMIN" }
        ],
        table: "menuDesigner",
        tableField: "name",
        type: "search"
      },
      {
        caption: "NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "userName",
        selectorType: "",
        staticSource: [{ name: "" }],
        table: "",
        tableField: "",
        type: "input"
      },
      {
        caption: "EMAIL",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "userEmail",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "MOBILE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "userMobile",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ADDRESS",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "userAddress",
        selectorType: "",
        staticSource: [{ name: "" }],
        table: "",
        tableField: "",
        type: "textarea"
      },
      {
        caption: "COMPANY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "BROOKLYNZ STAINLESS STEEL PTE LTD",
        enabled: "true",
        expanded: false,
        name: "userCompany",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "COMP INTRO TEXT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "compIntoText",
        numOfLines: "5",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "BACKGROUND IMAGE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "bgImage",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "YOUTUBE VID ID",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "vidUrl",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PROMO HEADER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "promoHeader",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PROMO DESCRIPTION",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "promoDescription",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "ENTER AS WORKER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "YES",
        expanded: false,
        name: "forceWorker",
        selectorType: "static",
        staticSource: [{ name: "YES" }, { name: "NO" }],
        type: "search"
      },
      {
        caption: "BUTTON1 TEXT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "btn1Text",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ACTION1",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "action1",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "BUTTON2 TEXT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "btn2Text",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ACTION2",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "action2",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "TABLE NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "tableName",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "TABLE NAME2",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "tableName2",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      }
    ],
    filters: ["roleName"],
    key: "17",
    lastAction: "",
    menu: "USER",
    name: "users",
    searchColumns: ["userName", "roleName"],
    updateDateTime: "",
    updateNotifyText: ""
  },
  {
    author: "",
    caption: "ACCOUNTS",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: [
      "accountName",
      "accountSubCategory",
      "accountDescription",
      "accountType",
      "gstRate",
      "defaultContraAccount"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "ACCOUNT NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "accountName",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "DESCRIPTION",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "accountDescription",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "textarea"
      },
      {
        caption: "GST RATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "0.07",
        expanded: false,
        name: "gstRate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ACCOUNT TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "accountType",
        selectorType: "static",
        staticSource: [
          { name: "EXPENSE" },
          { name: "INCOME" },
          { name: "ASSET" },
          { name: "LIABILITY" },
          { name: "CAPITAL" },
          { name: "SYS INTERNAL" }
        ],
        type: "search"
      },
      {
        caption: "SUB CATEGORY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "accountSubCategory",
        selectorType: "static",
        staticSource: [{ name: "INDIRECT EXPENSES" }, { name: "OTHER INCOME" }],
        type: "search"
      },
      {
        caption: "DEF CONTRA ACCOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "defaultContraAccount",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      },
      {
        caption: "ACCOUNTING RULES",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: true,
        name: "accountingRules",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "accountingRule"
      }
    ],
    filters: ["accountType"],
    key: "4",
    lastAction: "",
    menu: "ACCOUNTS",
    name: "accounts",
    searchColumns: ["accountName", "accountDescription"],
    updateDateTime: "",
    updateNotifyText: ""
  },
  {
    author: "",
    caption: "PAYMENT TYPES",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: ["paymentName"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "paymentName",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "DESCRIPTION",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "paymentDescription",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "DEFAULT ACCOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "defaultAccount",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      }
    ],
    key: "3",
    lastAction: "",
    menu: "PAYMENT TYPES",
    name: "paymentTypes",
    searchColumns: ["paymentName"],
    updateDateTime: "",
    updateNotifyText: ""
  },
  {
    author: "",
    caption: "EXPENSE",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: [
      "entryDate",
      "supplier",
      "expenseDescription",
      "account",
      "paymentType",
      "invoiceNumber",
      "gstAmount",
      "gstTotalAmount",
      "contraAccount"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "ENTRY DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "entryDate",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "DESCRIPTION",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "expenseDescription",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PROJECT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "project",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "projects",
        tableField: "projectName",
        type: "search"
      },
      {
        caption: "SUPPLIER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "supplier",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "suppliers",
        tableField: "supplierCompany",
        type: "search"
      },
      {
        caption: "SUPPLIER INVOICE#",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "invoiceNumber",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "EXPENSE ACCOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "account",
        otherFieldsToUpdate: [
          { src: "gstRate", tgt: "gstRate" },
          { src: "accountSubCategory", tgt: "accountSubCategory" }
        ],
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      },
      {
        caption: "SUB CATEGORY",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "accountSubCategory",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "GST RATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "gstRate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "BEFORE GST AMT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "amount",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PAYMENT TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "paymentType",
        otherFieldsToUpdate: [{ src: "defaultAccount", tgt: "contraAccount" }],
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "paymentTypes",
        tableField: "paymentName",
        type: "search"
      },
      {
        caption: "REF NUMBER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "referenceNumber",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "PAYMENT DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        expanded: false,
        name: "paymentDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "CONTRA ACCOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: true,
        name: "contraAccount",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      },
      {
        calcType: "mainFieldCalc",
        caption: "GST",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        formula: [
          { name: "", operand1: "amount", operand2: "gstRate", operation: "*" }
        ],
        name: "gstAmount",
        selectorType: "",
        staticSource: [{ name: "" }],
        triggerField: "amount",
        type: "calculation"
      },
      {
        calcType: "mainFieldCalc",
        caption: "TOTAL(INCL GST)",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        formula: [
          {
            name: "",
            operand1: "amount",
            operand2: "gstAmount",
            operation: "+"
          }
        ],
        name: "gstTotalAmount",
        selectorType: "",
        staticSource: [{ name: "" }],
        triggerField: "gstAmount",
        type: "calculation"
      }
    ],
    filters: ["entryDate"],
    key: "2",
    lastAction: "",
    menu: "EXPENSE",
    name: "expense",
    searchColumns: ["supplier", "account"],
    updateDateTime: "",
    updateNotifyText: ""
  },
  {
    author: "",
    caption: "BOOK KEEPING",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: [
      "bookingDate",
      "debitAccount",
      "creditAccount",
      "amount",
      "description"
    ],
    deleteNotifyText: "",
    fields: [
      {
        caption: "DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "bookingDate",
        otherFieldsToUpdate: [{ src: "", tgt: "" }],
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "DEBIT (RECEIVED BY)",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "debitAccount",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      },
      {
        caption: "CREDIT (TAKEN FROM)",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "creditAccount",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      },
      {
        caption: "AMOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "amount",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "DESCRIPTION",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "description",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "REFERENCE NUMBER",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "refNumber",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      }
    ],
    filters: ["bookingDate", "debitAccount", "creditAccount"],
    key: "1",
    lastAction: "",
    menu: "BOOK KEEPING",
    name: "accountingEntry",
    searchColumns: ["debitAccount", "creditAccount", "amount"],
    updateDateTime: "",
    updateNotifyText: ""
  },
  {
    author: "",
    caption: "ACCOUNT ENQUIRIES",
    createDateTime: "",
    createNotifyText: "",
    dashColumns: ["accEnquiryName", "enquiryDate", "accName"],
    deleteNotifyText: "",
    fields: [
      {
        caption: "ENQUIRY NAME",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        expanded: false,
        name: "accEnquiryName",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "input"
      },
      {
        caption: "ENQUIRY DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        expanded: false,
        name: "enquiryDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "ACCOUNT",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        defaultValue: "",
        enabled: "true",
        expanded: false,
        isMust: "true",
        name: "accName",
        selectorType: "table",
        staticSource: [{ name: "" }],
        table: "accounts",
        tableField: "accountName",
        type: "search"
      },
      {
        caption: "ENQUIRY TYPE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        enabled: "true",
        expanded: false,
        name: "enquiryType",
        selectorType: "static",
        staticSource: [
          { name: "ACCOUNT STATEMENT" },
          { name: "DAILY BALANCE VIEW" }
        ],
        type: "search"
      },
      {
        caption: "FROM DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        expanded: false,
        name: "fromDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      },
      {
        caption: "TO DATE",
        colDefs: [{ editable: true, key: "", name: "", resizable: true }],
        dateFormat: "dd-MM-yyyy",
        dateFormatOut: "DD-MM-YYYY",
        dateMaxDetail: "day",
        defaultValue: "currentDate",
        expanded: false,
        name: "toDate",
        selectorType: "",
        staticSource: [{ name: "" }],
        type: "calendar"
      }
    ],
    filters: ["accName", "enquiryDate"],
    key: "0",
    lastAction: "",
    menu: "ACCOUNT ENQUIRY",
    name: "accountEnquiry",
    searchColumns: ["accEnquiryName", "accName", "enquiryDate"],
    updateDateTime: "",
    updateNotifyText: ""
  }
];



// WEBPACK FOOTER //
// ./src/staticData/tCreateTable.js